import LearningExperience from './LearningExperienceMobile';

export default LearningExperience;
